import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=fba918f8&scoped=true"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=fba918f8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba918f8",
  null
  
)

export default component.exports